<i
  *ngIf="phxPrefixIcon && !phxLoading"
  phx-icon
  class="phx-button-upsell-prefix"
  [phxIcon]="phxPrefixIcon"
  color="currentColor"
></i>
<phx-spinner *ngIf="phxLoading" phxSize="medium" phxBackground="dark" class="phx-button-upsell-loading-icon"></phx-spinner>
<span *ngIf="!phxLoading" class="phx-button-upsell-content">
  <ng-content></ng-content>
</span>
